import { render, staticRenderFns } from "./Stator.vue?vue&type=template&id=5d7a90f5&"
import script from "./Stator.vue?vue&type=script&lang=js&"
export * from "./Stator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports